module.exports = __webpack_public_path__ + "73c1b77d.webp";